/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Bonisoft Backend API
 * Bonisoft Backend API
 * OpenAPI spec version: 1
 */

export type InAppNotificationActionType = typeof InAppNotificationActionType[keyof typeof InAppNotificationActionType];


export const InAppNotificationActionType = {
  ShopModule: 'ShopModule',
  ActionModule: 'ActionModule',
  ServiceModule: 'ServiceModule',
  Profile: 'Profile',
  Wallet: 'Wallet',
  ExternalUrl: 'ExternalUrl',
} as const;
